import React,{useState,useEffect} from 'react';
// import Header from '../lib-ui/Header';
import { Stack, Box } from '@mui/material';
import core from '../assets/image/core2.png';
import '../style/fonts.css';
import '../style/blink.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faCube } from '@fortawesome/free-solid-svg-icons';



export default () => {

    const [enColor,setEnColor] = useState('#666666');
    const [krColor,setKrColor] = useState('#666666');
    const [jpColor,setJpColor] = useState('#666666');



    useEffect(()=>{

        document.title = "NSTRUCT";
        const str = window.location.pathname;



        if( String(str).startsWith("/en") ){
            setEnColor("#ffffff");
        }else if( String(str).startsWith("/kr") ){
            setKrColor("#ffffff");
        }else if( String(str).startsWith("/jp") ){
            setJpColor("#ffffff");
        }   


    },[]);

    function goto_page(v){
        document.location.href=v;
    }


    return (
        <table style={{ width: '100%', height: '100vh', backgroundColor: '#000000', color: '#ffffff', borderStyle: 'solid', borderWidth: '0px', borderCollapse: 'collapse' }} >
            <tr style={{ height: '40px' }}>
                <td style={{ height: '40px', textAlign: 'left', fontFamily: 'kanit', fontSize: '18px', verticalAlign: 'center', color: '#ffffff' }}>

                <table style={{ width: '100%', height: '40px', borderStyle: 'solid', borderWidth: '0px', borderCollapse: 'collapse' }}>
                        <tr>
                            <td style={{ height: '40px', textAlign: 'left', fontFamily: 'kanit', fontSize: '18px', verticalAlign: 'center', color: '#ffffff' }}>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{fontWeight:'bold',color:'#ffffff',marginRight:'1px'}}>N</span><span style={{fontWeight:'normal',color:'#aaaaaa'}}>STRUCT</span>
                            </td>
                            <td style={{ textAlign: 'right', fontFamily: '', fontSize: '13px' }}>
                                <span style={{ fontSize: '12px', cursor: 'pointer', color: `${enColor}` }} onClick={() => { goto_page('/en') }}>ENGLISH</span>&nbsp;&nbsp;&nbsp;&nbsp; <span style={{ fontSize: '11px', cursor: 'pointer', color: `${krColor}` }} onClick={() => { goto_page('/kr') }}>한국어</span> &nbsp;&nbsp;&nbsp; <span style={{ fontSize: '11px', cursor: 'pointer', color: `${jpColor}` }} onClick={() => { goto_page('/jp') }}>日本語</span>  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </td>
                        </tr>
                    </table>

                </td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center', verticalAlign: 'center', paddingTop: '160px' }}>
                    <div style={{ minWidth: '80px',maxWidth:'300px', display: 'inline-block', margin: '0px auto' }}>
                        <img src={core} style={{ width: '100%', marginTop: '0px' }} />
                    </div>

                    <div style={{ margin: '0px auto', height: '60px', fontFamily: 'tiny5', fontSize: '19px', color: '#ffffff' }}>&nbsp;&nbsp;READY > <span className={'blink'}>_</span>
                    </div>
                    <div style={{ height: '80px' }}>&nbsp;&nbsp;</div>

                    <table style={{ width: '320px', borderStyle: 'solid', borderWidth: '0px', borderCollapse: 'collapse', margin: '0px auto' }}>
                        <tr>
                            <td style={{ width: '80px', height: '40px', textAlign: 'center' }}>
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '14px', color: '#ffffff', fontFamily: 'kanit' }}>Products</div>
                                <FontAwesomeIcon icon={faCube} style={{ fontSize: '30px', marginBottom: '11px', marginTop: '11px' }} />
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '11px', color: '#666666' }}>Coming soon</div>
                            </td>
                            <td style={{ width: '80px', height: '40px', textAlign: 'center' }}>
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '14px', color: '#ffffff', fontFamily: 'kanit' }}>Services</div>
                                <FontAwesomeIcon icon={faCube} style={{ fontSize: '30px', marginBottom: '11px', marginTop: '11px' }} />
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '11px', color: '#666666' }}>Coming soon</div>
                            </td>
                            <td style={{ width: '80px', height: '20px', padding: '0px', margin: '0px', width: '80px', height: '40px', textAlign: 'center' }}>
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '14px', color: '#ffffff', fontFamily: 'kanit' }}>IR</div>
                                <FontAwesomeIcon icon={faCube} style={{ fontSize: '30px', marginBottom: '11px', marginTop: '11px' }} />
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '11px', color: '#666666' }}>Coming soon</div>
                            </td>
                            <td style={{ width: '80px', height: '20px', padding: '0px', margin: '0px', width: '80px', height: '40px', textAlign: 'center' }}>
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '14px', color: '#ffffff', fontFamily: 'kanit' }}>Contact</div>
                                <FontAwesomeIcon icon={faCube} style={{ fontSize: '30px', marginBottom: '11px', marginTop: '11px' }} />
                                <div style={{ height: '20px', padding: '0px', margin: '0px', fontSize: '11px', color: '#666666' }}>Coming soon</div>
                            </td>
                        </tr>
                    </table>
                    <div style={{ height: '200px' }}>&nbsp;&nbsp;</div>
                </td>
            </tr>
            <tr style={{ height: '200px' }}>
                <td style={{ height: '200px', textAlign: 'left', fontSize: '13px', verticalAlign: 'center', color: '#ffffff' }}>
                    <div style={{ lineHeight: '20px', fontSize: '11px', paddingLeft: '40px', fontFamily:'Noto Sans' }}>
                        NSTRUCT Inc.<br />
                        All rights reserved. &copy;2025<br />

                    </div>
                </td>
            </tr>
        </table>
);
}